import { useTranslation } from 'react-i18next';

import { DataPanelAutoWrapInlineItem, DataPanelItem, Divider } from '@/ui';
import type { AppleEedEmergencyContact } from '@ngsos/portal-core/commands';
import { ContactRow } from '../shared/ContactRow';

export type AppleEedEmergencyContactPanelItemProps = {
  contacts?: readonly AppleEedEmergencyContact[] | null;
};

export function AppleEedEmergencyContactPanelItem({ contacts }: AppleEedEmergencyContactPanelItemProps) {
  const { t } = useTranslation();

  if (contacts == null || contacts.length === 0) {
    return null;
  }

  return (
    <DataPanelItem
      title={t('Incident_InfoPanel_ClosePersonContact')}
      testID="incident-apple-eed-emergency-contacts-list"
    >
      {contacts.map((contact, index) => (
        <div
          key={`${contact.name ?? ''}-${contact.tel ?? ''}-${index}`}
          data-testid="incident-apple-eed-emergency-contact-list-item"
        >
          <ContactRow name={contact.name ?? null} phoneNumber={contact.tel ?? null} />

          <DataPanelAutoWrapInlineItem
            title={t('Incident_InfoPanel_AppleEed_EmergencyContact_Relationship')}
            value={contact.relationship ?? undefined}
            showEmptyPlaceholder
          />
          <Divider dense />
        </div>
      ))}
    </DataPanelItem>
  );
}
